export const authenticationKeys = {
  currentUser: () => ["users", "me"] as const,
};

export const adminKeys = {
  tests: () => ["admin", "tests"] as const,
  users: () => ["admin", "users"] as const,
  candidates: () => ["admin", "candidates"] as const,
  candidatesSummary: () => ["admin", "candidates", "summary"] as const,
  candidateAnswers: () => ["admin", "candidates", "answers"] as const,
  candidateActive: () => ["admin", "candidates", "setActive"] as const,
  testsById: (id: string) => [...adminKeys.tests(), id] as const,
  userResults: (username: string) => ["admin", "candidates", username] as const,
};

export const publicKeys = {
  testsByPublicId: (publicId: string) => ["public", "tests", publicId] as const,
  candidateByPublicId: (publicId: string) => ["users", publicId] as const,
  testByType: (evaluationType: string) => ["users", "test", evaluationType] as const,
  result: () => ["users", "ability"] as const,
  automatedCandidate: () => ["public", "test", "speech"] as const,
  automatedCandidatesR: () => ["public", "test", "sR"] as const,
  licenseRequest: () => ["licenseRequest"] as const,
  userResults: (username: string) => ["candidates", "candidateResult", username] as const,
  password: () => ["public", "candidates", "password"] as const,
};

export const teacherKeys = {
  userResults: (username: string) => ["teacher","candidates", "candidateResult", username] as const,
};

export const userKeys = {
  acceptTerms: () => ["users", "updateAcceptsTerms"] as const,
};
